<template>
    <div>
        <b-row>
            <b-col lg="1" cols="12">
                <b-button class="btn-block" @click="returnPage" variant="primary">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-bodyguard-service-view :bodyguard-service="selectedBodyguardService" />
            </b-col>
        </b-row>
        <br />
        <b-row>
            <b-col cols="12" lg="6">
                <b-button
                    variant="primary"
                    class="btn-block"
                    @click="$bus.$emit('service-checkpoint-form.open')"
                >
                    <i class="fa fa-map-marker"></i> Agregar punto de
                    control
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <h5>Puntos de control</h5>
                <app-service-checkpoints-List
                    :data="selectedBodyguardService.body_guard_service_checkpoints"
                    @remove-service="startRemoveCheckpoint"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" lg="6">
                <b-button
                    variant="primary"
                    class="btn-block"
                    @click="$bus.$emit('service-novelty-form.open')"
                >
                    <i class="fa fa-plus-circle"></i> Agregar nueva novedad
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <h5>Novedades</h5>
                <app-service-notes-List :data="novelties" @remove-novelty="onRemoveNovelty" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" lg="6">
                <b-button
                    variant="success"
                    class="btn-block"
                    @click="$bus.$emit('finish-service-form.open')"
                >
                    <i class="fa fa-check-square-o"></i> Terminar
                    servicio
                </b-button>
            </b-col>
        </b-row>

        <!-- inicio de pop up's -->
        <app-pop-up title="Confirmación" id="checkpoint-remove">
            <div slot="body">
                <h2>
                    ¿Esta seguro que desea eliminar este punto de control del
                    servicio de guardaespalda?
                </h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteCheckpoint(selectedCheckpoint)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Formulario punto de control"
            id="service-checkpoint-form"
            :onShowUp="func => $bus.$emit('current-location.get')"
            :onClose="cleanFormCheckpoint"
        >
            <div class="body" slot="body">
                <app-service-checkpoint-form
                    :serviceId="selectedBodyguardService.id"
                    :onSave="onSaveCheckpoint"
                />
            </div>
            <div slot="buttons">
                <b-button
                    variant="confirm"
                    :disabled="inProgress"
                    class="btn-block-xs-only"
                    @click="$bus.$emit('service-checkpoint-form.save')"
                >
                    <i class="fa fa-floppy-o"></i> Guardar punto de
                    control
                </b-button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Finalizar servicio"
            id="finish-service-form"
            :onShowUp="
                func => $bus.$emit('bodyguard-service-signature-pad.rezize')
            "
            :onClose="cleanFormFinishService"
        >
            <div class="body" slot="body">
                <app-finish-service-form
                    :service="selectedBodyguardService"
                    :onFinish="onFinishService"
                />
            </div>
            <div slot="buttons">
                <b-button
                    variant="confirm"
                    class="btn-block-xs-only"
                    @click="$bus.$emit('finish-service-form.save')"
                    :disabled="inProgress"
                >
                    <i class="fa fa-floppy-o"></i> Finalizar servicio
                </b-button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Formulario de novedades"
            id="service-novelty-form"
            :onClose="cleanFormNovelty"
        >
            <div class="body" slot="body">
                <app-service-novelty-form
                    :serviceId="selectedBodyguardService.id"
                    ref="novelty-form"
                    @success="onSuccessNovelty"
                />
            </div>
            <div slot="buttons">
                <b-button
                    variant="confirm"
                    :disabled="inProgress"
                    class="btn-block-xs-only"
                    @click="$refs['novelty-form'].saveNovelty()"
                >
                    <i class="fa fa-floppy-o"></i> Guardar Novedad
                </b-button>
            </div>
        </app-pop-up>
        <!-- fin de pop up's -->
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '../../../../store/commitTypes'
import BodyguardServiceForm from '../BodyguardServices/BodyguardServiceForm/BodyguardServiceForm'
import ServiceCheckpointForm from './ServiceCheckpointForm/ServiceCheckpointForm'
import FinishServiceForm from './FinishServiceForm/FinishServiceForm'
import ServiceCheckpointsList from './ServiceCheckpointsList/ServiceCheckpointsList'
import bodyguardRepository from '../../../../repositories/bodyguard.repository'
import vehicularForm from '../BodyguardServices/BodyguardServiceForm/BodyguardServiceFormVehicular'
import personalForm from '../BodyguardServices/BodyguardServiceForm/BodyguardServiceFormPersonal'
import BodyguardServiceView from './BodyguardServiceView/BodyguardServiceView'
import ServiceNotesList from './ServiceNotesList/ServiceNoteList'
import ServiceNoveltyForm from './ServiceNoveltyForm/ServiceNoveltyForm'

export default {
    components: {
        appBodyguardServiceForm: BodyguardServiceForm,
        appServiceCheckpointForm: ServiceCheckpointForm,
        appFinishServiceForm: FinishServiceForm,
        appServiceCheckpointsList: ServiceCheckpointsList,
        appVehicularForm: vehicularForm,
        appPersonalForm: personalForm,
        appBodyguardServiceView: BodyguardServiceView,
        appServiceNotesList: ServiceNotesList,
        appServiceNoveltyForm: ServiceNoveltyForm,
    },
    computed: {
        ...mapGetters(['selectedBodyguardService']),
    },
    data() {
        return {
            selectedCheckpoint: '',
            theForm: '',
            novelties: [],
        }
    },
    methods: {
        ...mapMutations({
            setSelectedBodyguardService:
                mutations.SET_SELECTED_BODYGUARD_SERVICE,
        }),
        async loadNovelties() {
            const { data } = await repo.get(
                `bodyguard-services/novelties/${this.selectedBodyguardService.id}`
            )
            this.novelties = data
        },
        onSuccessNovelty(data) {
            toastr.success(data.msg)
            this.$bus.$emit('service-novelty-form.close')
            this.loadNovelties()
        },
        onSave(service) {
            this.setSelectedBodyguardService(service)
        },
        cleanFormCheckpoint() {
            this.$bus.$emit('service-checkpoint-form.clean')
        },
        cleanFormNovelty() {
            this.$bus.$emit('service-novelty-form.clean')
        },
        onSaveCheckpoint(checkpoint) {
            this.selectedBodyguardService.body_guard_service_checkpoints.push(
                checkpoint
            )
            this.setSelectedBodyguardService(this.selectedBodyguardService)
            this.$bus.$emit('service-checkpoint-form.close')
        },
        cleanFormFinishService() {
            this.$bus.$emit('finish-service-form.clean')
        },
        onFinishService() {
            this.setSelectedBodyguardService(null)
            this.$bus.$emit('finish-service-form.close')
            this.$router.push({ name: 'bodyguardServicesPage' })
        },
        startRemoveCheckpoint(checkpoint) {
            this.selectedCheckpoint = Object.assign({}, checkpoint)
            this.$bus.$emit('checkpoint-remove.open')
        },
        deleteCheckpoint(checkpoint) {
            const br = { ...bodyguardRepository }
            br.deleteCheckpoint(checkpoint.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.setSelectedBodyguardService(data.service)
                        this.$bus.$emit('checkpoint-remove.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'No se pudo borrar el punto de control del servicio de guardaespalda'
                    )
                })
        },
        returnPage() {
            this.setSelectedBodyguardService(null)
            this.$router.push({ name: 'bodyguardServicesPage' })
        },
        initialize() {
            this.theForm = {
                vehicular: 'appVehicularForm',
                personal: 'appPersonalForm',
            }[this.selectedBodyguardService.type]
        },
        async onRemoveNovelty(id) {
            const { data } = await repo.delete(
                `bodyguard-services/delete-novelty/${id}`
            )
            if (data.status) {
                toastr.success(data.msg)
                this.loadNovelties()
            } else {
                toastr.error(data.msg)
            }
        },
    },
    mounted() {
        this.initialize()
        this.loadNovelties()
    },
}
</script>
